export default "* Stafet\n* Samarbejde";